define('formkit/behavior/progressively.disclose.on.displayed.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');

  var ProgressivelyDiscloseOnDisplayedBehavior = Mn.Behavior.extend({
    defaults: {
      showAnimation: 'slide down',
      showDuration: '300ms',
      hideAnimation: 'slide down',
      hideDuration: '300ms',
    },

    initialize: function() {
      this.listenToOnce(this.view, 'before:render', function() {
        this.setupProgressiveDisclosure();
      });
    },

    setupProgressiveDisclosure: function() {
      var model = this.view.getOption('model');

      this.view.visible = model.get('displayed');

      this.listenTo(model, 'change:displayed', function(model, value, options) {
        if (value == true) {
          this.view.show({
            animation: this.getOption('showAnimation'),
            duration: this.getOption('showDuration'),
          });
        } else if (value == false) {
          this.view.hide({
            animation: this.getOption('hideAnimation'),
            duration: this.getOption('hideDuration'),
          });
        }

        if (this.view.form) {
          this.view.form.trigger('formObject:disclose', model, value);
        }
      });
    },
  });

  module.exports = ProgressivelyDiscloseOnDisplayedBehavior;
});

